import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

function InlineLoader({
	size = 16,
	thickness = 5,
	ariaLabel = 'loading',
	sx,
	...props
}) {
	return (
		<CircularProgress
			size={size}
			thickness={thickness}
			color="inherit"
			aria-label={ariaLabel}
			sx={sx}
			{...props}
		/>
	);
}

InlineLoader.propTypes = {
	size: PropTypes.number,
	thickness: PropTypes.number,
	ariaLabel: PropTypes.string,
	sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default InlineLoader;
